import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=509fa72a&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=509fa72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509fa72a",
  null
  
)

export default component.exports